module.exports = __webpack_public_path__ + "static/img/oil2.26af5d0f.png";